/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Icon, Image, Text, View } from "@aws-amplify/ui-react";
export default function NoCrystalBall(props) {
  const { overrides, ...rest } = props;
  return (
    <View
      width="1271px"
      height="660px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "NoCrystalBall")}
      {...rest}
    >
      <Flex
        gap="25px"
        direction="column"
        width="552px"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        position="absolute"
        top="13.64%"
        bottom="13.94%"
        left="56.57%"
        right="0%"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464702")}
      >
        <Flex
          padding="0px 0px 0px 0px"
          width="500px"
          height="170px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          {...getOverrideProps(overrides, "Content")}
        >
          <Text
            fontFamily="Inter"
            fontSize="31px"
            fontWeight="400"
            color="rgba(11,20,31,1)"
            lineHeight="47px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="500px"
            height="unset"
            gap="unset"
            alignItems="unset"
            position="absolute"
            top="76px"
            left="0px"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="The Info you Need.&#x2028;No Resume To Read. "
            {...getOverrideProps(
              overrides,
              "The Info you Need.\u2028No Resume To Read.\u00A0"
            )}
          ></Text>
          <View
            padding="0px 0px 0px 0px"
            width="493px"
            height="60px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0px"
            left="0px"
            {...getOverrideProps(overrides, "Title")}
          >
            <Text
              fontFamily="Inter"
              fontSize="40px"
              fontWeight="700"
              color="rgba(11,20,31,1)"
              lineHeight="60px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              position="absolute"
              top="0px"
              left="0px"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="No Crystal Ball Required. "
              {...getOverrideProps(
                overrides,
                "No Crystal Ball Required.\u00A0"
              )}
            ></Text>
          </View>
        </Flex>
        <Flex
          gap="14px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="center"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464118")}
        >
          <Flex
            gap="16px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="center"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464114")}
          >
            <View
              width="29.5px"
              height="29.5px"
              {...getOverrideProps(overrides, "Check753724380")}
            ></View>
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(61,77,103,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Only Top Qualifiers For Your Company "
              {...getOverrideProps(
                overrides,
                "Only Top Qualifiers For Your Company\u00A0"
              )}
            ></Text>
          </Flex>
          <Icon
            width="507px"
            height="0px"
            viewBox={{ minX: 0, minY: 0, width: 507, height: 1 }}
            paths={[
              {
                d: "M0 0.5L507 0.5L507 -0.5L0 -0.5L0 0.5Z",
                stroke: "rgba(221,221,221,1)",
                fillRule: "nonzero",
                strokeWidth: 1,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            {...getOverrideProps(overrides, "Line 3")}
          ></Icon>
          <Flex
            gap="16px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464115")}
          >
            <View
              width="29.5px"
              height="29.5px"
              {...getOverrideProps(overrides, "Check753724384")}
            ></View>
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(92,102,112,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="468px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Protect Your Corporate Culture "
              {...getOverrideProps(
                overrides,
                "Protect Your Corporate Culture\u00A0"
              )}
            ></Text>
          </Flex>
          <Icon
            width="507px"
            height="0px"
            viewBox={{ minX: 0, minY: 0, width: 507, height: 1 }}
            paths={[
              {
                d: "M0 0.5L507 0.5L507 -0.5L0 -0.5L0 0.5Z",
                stroke: "rgba(221,221,221,1)",
                fillRule: "nonzero",
                strokeWidth: 1,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            {...getOverrideProps(overrides, "Line 4")}
          ></Icon>
          <Flex
            gap="16px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464116")}
          >
            <View
              width="29.5px"
              height="29.5px"
              {...getOverrideProps(overrides, "Check753724388")}
            ></View>
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(92,102,112,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="468px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Strong Candidates Create Strong Teams "
              {...getOverrideProps(
                overrides,
                "Strong Candidates Create Strong Teams\u00A0"
              )}
            ></Text>
          </Flex>
          <Icon
            width="507px"
            height="0px"
            viewBox={{ minX: 0, minY: 0, width: 507, height: 1 }}
            paths={[
              {
                d: "M0 0.5L507 0.5L507 -0.5L0 -0.5L0 0.5Z",
                stroke: "rgba(221,221,221,1)",
                fillRule: "nonzero",
                strokeWidth: 1,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            {...getOverrideProps(overrides, "Line 5")}
          ></Icon>
          <Flex
            gap="16px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464117")}
          >
            <View
              width="29.5px"
              height="29.5px"
              {...getOverrideProps(overrides, "Check753724392")}
            ></View>
            <Text
              fontFamily="Inter"
              fontSize="18px"
              fontWeight="400"
              color="rgba(92,102,112,1)"
              lineHeight="27px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="468px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Contributors - not Inhibitors. "
              {...getOverrideProps(
                overrides,
                "Contributors - not Inhibitors.\u00A0"
              )}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="0"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          position="relative"
          borderRadius="4px"
          padding="16px 24px 16px 24px"
          backgroundColor="rgba(204,164,59,1)"
          {...getOverrideProps(overrides, "Button")}
        >
          <Text
            fontFamily="Inter"
            fontSize="16px"
            fontWeight="700"
            color="rgba(255,255,255,1)"
            lineHeight="24px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Start Hiring with Ikimy"
            {...getOverrideProps(overrides, "label753724396")}
          ></Text>
        </Flex>
      </Flex>
      <Flex
        gap="34px"
        direction="row"
        width="566.12px"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-end"
        position="absolute"
        top="0%"
        bottom="0%"
        left="0%"
        right="55.46%"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Elements")}
      >
        <Image
          width="520px"
          height="660px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          borderRadius="11px"
          padding="0px 0px 0px 0px"
          objectFit="unset"
          {...getOverrideProps(overrides, "Image")}
        ></Image>
      </Flex>
      <View
        padding="0px 0px 0px 0px"
        width="277.12px"
        height="235.41px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="50.45%"
        bottom="13.88%"
        left="30.45%"
        right="47.75%"
        {...getOverrideProps(overrides, "Group 1160463945")}
      >
        <Flex
          gap="17.51351547241211px"
          direction="column"
          width="243.88px"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          position="absolute"
          top="11.28%"
          bottom="-0.19%"
          left="-0.16%"
          right="12.15%"
          border="0.44px SOLID rgba(217,222,231,1)"
          boxShadow="0px 3.4591007232666016px 3.4591007232666016px rgba(0, 0, 0, 0.25)"
          borderRadius="9.085589677095413px"
          padding="17.51351547241211px 17.51351547241211px 17.51351547241211px 17.51351547241211px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Frame 1160464590")}
        >
          <Flex
            gap="7.005405902862549px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="center"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            border="0.44px SOLID rgba(209,209,210,1)"
            padding="4.816216200590134px 6.5675680339336395px 4.816216200590134px 6.5675680339336395px"
            {...getOverrideProps(overrides, "Frame 427319017")}
          >
            <Flex
              width="12.26px"
              height="12.26px"
              {...getOverrideProps(overrides, "substep/completed753724460")}
            ></Flex>
            <Flex
              gap="4.378378868103027px"
              direction="row"
              width="unset"
              height="19.7px"
              justifyContent="space-between"
              alignItems="center"
              grow="1"
              shrink="1"
              basis="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1168753724461")}
            >
              <Flex
                gap="4.378378868103027px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="space-between"
                alignItems="center"
                grow="1"
                shrink="1"
                basis="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1088753724462")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="10.508108139038086px"
                  fontWeight="600"
                  color="rgba(45,63,92,1)"
                  lineHeight="13.135136604309082px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Role Definition"
                  {...getOverrideProps(overrides, "label753724463")}
                ></Text>
                <View
                  width="10.07px"
                  height="5.25px"
                  {...getOverrideProps(overrides, "AccordionChevron753724464")}
                ></View>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            gap="7.005405902862549px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="center"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            border="0.44px SOLID rgba(209,209,210,1)"
            padding="4.816216200590134px 6.5675680339336395px 4.816216200590134px 6.5675680339336395px"
            {...getOverrideProps(overrides, "Frame 427319019")}
          >
            <Flex
              width="12.26px"
              height="12.26px"
              {...getOverrideProps(overrides, "substep/completed753724466")}
            ></Flex>
            <Flex
              gap="4.378378868103027px"
              direction="row"
              width="unset"
              height="19.7px"
              justifyContent="space-between"
              alignItems="center"
              grow="1"
              shrink="1"
              basis="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1168753724467")}
            >
              <Flex
                gap="4.378378868103027px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="space-between"
                alignItems="center"
                grow="1"
                shrink="1"
                basis="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1088753724468")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="10.508108139038086px"
                  fontWeight="600"
                  color="rgba(45,63,92,1)"
                  lineHeight="13.135136604309082px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Employment Context"
                  {...getOverrideProps(overrides, "label753724469")}
                ></Text>
                <View
                  width="10.07px"
                  height="5.25px"
                  {...getOverrideProps(overrides, "AccordionChevron753724470")}
                ></View>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            gap="7.005405902862549px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="center"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            border="0.44px SOLID rgba(209,209,210,1)"
            padding="4.816216200590134px 6.5675680339336395px 4.816216200590134px 6.5675680339336395px"
            {...getOverrideProps(overrides, "Frame 427319024")}
          >
            <Flex
              width="12.26px"
              height="12.26px"
              {...getOverrideProps(overrides, "SubStepNumber753724472")}
            ></Flex>
            <Flex
              gap="4.378378868103027px"
              direction="row"
              width="unset"
              height="19.7px"
              justifyContent="space-between"
              alignItems="center"
              grow="1"
              shrink="1"
              basis="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1168753724473")}
            >
              <Flex
                gap="4.378378868103027px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="space-between"
                alignItems="center"
                grow="1"
                shrink="1"
                basis="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1088753724474")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="10.508108139038086px"
                  fontWeight="600"
                  color="rgba(45,63,92,1)"
                  lineHeight="13.135136604309082px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Work Location"
                  {...getOverrideProps(overrides, "label753724475")}
                ></Text>
                <View
                  width="10.07px"
                  height="5.25px"
                  {...getOverrideProps(overrides, "AccordionChevron753724476")}
                ></View>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            gap="7.005405902862549px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="center"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            border="0.44px SOLID rgba(209,209,210,1)"
            padding="4.816216200590134px 6.5675680339336395px 4.816216200590134px 6.5675680339336395px"
            {...getOverrideProps(overrides, "Frame 427319023")}
          >
            <Flex
              width="12.26px"
              height="12.26px"
              {...getOverrideProps(overrides, "SubStepNumber753724478")}
            ></Flex>
            <Flex
              gap="4.378378868103027px"
              direction="row"
              width="unset"
              height="19.7px"
              justifyContent="space-between"
              alignItems="center"
              grow="1"
              shrink="1"
              basis="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1168753724479")}
            >
              <Flex
                gap="4.378378868103027px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="space-between"
                alignItems="center"
                grow="1"
                shrink="1"
                basis="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1088753724480")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="10.508108139038086px"
                  fontWeight="600"
                  color="rgba(45,63,92,1)"
                  lineHeight="13.135136604309082px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Travel Requirements "
                  {...getOverrideProps(overrides, "label753724481")}
                ></Text>
                <View
                  width="10.07px"
                  height="5.25px"
                  {...getOverrideProps(overrides, "AccordionChevron753724482")}
                ></View>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <View
          padding="0px 0px 0px 0px"
          width="25.09px"
          height="37.53px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="9.32%"
          bottom="74.74%"
          left="100%"
          right="-9.05%"
          transformOrigin="top left"
          transform="rotate(125.75deg)"
          {...getOverrideProps(overrides, "Group 137")}
        >
          <Icon
            width="24px"
            height="0px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 23.15603542327881,
              height: 6.308565616607666,
            }}
            paths={[
              {
                d: "M1 -2C0.447715 -2 0 -1.55228 0 -1C0 -0.447715 0.447715 0 1 0L1 -2ZM23 0C23.5523 0 24 -0.447715 24 -1C24 -1.55228 23.5523 -2 23 -2L23 0ZM1 0L23 0L23 -2L1 -2L1 0Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeWidth: 2,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0%"
            bottom="100%"
            left="23.71%"
            right="-19.37%"
            transformOrigin="top left"
            transform="rotate(39.01deg)"
            {...getOverrideProps(overrides, "Line 9")}
          ></Icon>
          <Icon
            width="24px"
            height="0px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 16.899431705474854,
              height: 17.041395664215088,
            }}
            paths={[
              {
                d: "M1 -2C0.447715 -2 0 -1.55228 0 -1C0 -0.447715 0.447715 0 1 0L1 -2ZM23 0C23.5523 0 24 -0.447715 24 -1C24 -1.55228 23.5523 -2 23 -2L23 0ZM1 0L23 0L23 -2L1 -2L1 0Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeWidth: 2,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="49.33%"
            bottom="50.67%"
            left="5.52%"
            right="-1.18%"
            transformOrigin="top left"
            transform="rotate(9.01deg)"
            {...getOverrideProps(overrides, "Line 10")}
          ></Icon>
          <Icon
            width="24px"
            height="0px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 6.114639759063721,
              height: 23.20799732208252,
            }}
            paths={[
              {
                d: "M1 -2C0.447715 -2 0 -1.55228 0 -1C0 -0.447715 0.447715 0 1 0L1 -2ZM23 0C23.5523 0 24 -0.447715 24 -1C24 -1.55228 23.5523 -2 23 -2L23 0ZM1 0L23 0L23 -2L1 -2L1 0Z",
                stroke: "rgba(71,160,80,1)",
                fillRule: "nonzero",
                strokeWidth: 2,
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="100%"
            bottom="0%"
            left="0%"
            right="4.34%"
            transformOrigin="top left"
            transform="rotate(-20.99deg)"
            {...getOverrideProps(overrides, "Line 11")}
          ></Icon>
        </View>
      </View>
    </View>
  );
}
